var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.uploading),expression:"uploading"}],staticClass:"rich-editor"},[_c('quill-editor',{ref:"editor",attrs:{"options":_vm.editorOption,"disabled":_vm.disabled},on:{"change":_vm.onChange},model:{value:(_vm.inner),callback:function ($$v) {_vm.inner=$$v},expression:"inner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }